import all from './all';
import cancel from './cancel';
import changeDueDate from './changeDueDate';
import changeStatus from './changeStatus';
import checkout from './checkout';
import create from './create';
import { getAppointmentById } from './getAppointmentById';

export default {
  all,
  cancel,
  changeDueDate,
  changeStatus,
  getAppointmentById,
  checkout,
  create,
};
